import React from 'react';
import { Typography } from '@mui/material';
import { formatCompact, formatPercentage } from '../../../utils/formatters';
import { ColorDot, StyledLegendLabel } from '../Legend.styles';
import { useTableLegendRow } from './useTableLegendRow';

export const LabelCell = () => {
  const { color, label, ariaPrefix } = useTableLegendRow();
  return (
    <StyledLegendLabel
      variant="caption"
      display="flex"
      alignItems="flex-start"
      sx={{ overflow: 'hidden', minWidth: 0 }}
      id={`${ariaPrefix}_label`}>
      <span className="mt-[5px] inline-flex shrink-0">
        <ColorDot color={color} />
      </span>
      <Typography variant="caption" className="line-clamp-2 min-w-0 [overflow-wrap:anywhere]">
        {label}
      </Typography>
    </StyledLegendLabel>
  );
};

export const ValueCell = () => {
  const { value, ariaPrefix } = useTableLegendRow();
  return (
    <StyledLegendLabel
      justifySelf="end"
      noWrap
      variant="caption"
      sx={{ color: 'var(--content-base-secondary)' }}
      id={`${ariaPrefix}_value`}>
      {formatCompact.format(value)}
    </StyledLegendLabel>
  );
};

export const ShareCell = () => {
  const { value, total, ariaPrefix } = useTableLegendRow();
  return (
    <StyledLegendLabel
      justifySelf="end"
      noWrap
      variant="caption"
      sx={{ color: 'var(--content-base-secondary)' }}
      id={`${ariaPrefix}_percent`}>
      {total ? formatPercentage.format(value / total) : '0'}
    </StyledLegendLabel>
  );
};

export const TableLegendCells = ({
  showLabel = true,
  showShare = true,
  showValue = true,
}: {
  showLabel?: boolean;
  showShare?: boolean;
  showValue?: boolean;
}) => (
  <>
    {showLabel && <LabelCell />}
    {showValue && <ValueCell />}
    {showShare && <ShareCell />}
  </>
);
